export default __webpack_public_path__ + "static/media/icon-person-error-male-mobile.0fe5df31.svg";